import React, { useEffect, useState } from 'react';

const Episode = ({ content, available, firstElement, userDefi, userNextChapter }) => {
  const [timeLeft, setTimeLeft] = useState('');
  const [nextTimeLeft, setNextTimeLeft] = useState('');
  const [dayLeft, setDayLeft] = useState(0);

  useEffect(() => {
    if (firstElement && content?.expiration_date) {
      const updateCountdown = () => {
        const now = new Date();
        const expirationDate = new Date(content.expiration_date);
        const timeDiff = expirationDate - now;

        if (timeDiff <= 0) {
          setTimeLeft('Expiré');
          return;
        }

        const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
        const seconds = Math.floor((timeDiff / 1000) % 60);
        setDayLeft(days);

        const formatNumber = (num) => (num < 10 ? `0${num}` : num);
        const dayLabel = days === 1 ? 'jour' : 'jours';

        setTimeLeft(
          `${days} ${dayLabel}, ${formatNumber(hours)}h ${formatNumber(minutes)}m ${formatNumber(seconds)}s`
        );
      };

      updateCountdown();
      const interval = setInterval(updateCountdown, 1000);
      return () => clearInterval(interval);
    }
  }, [content?.expiration_date, firstElement]);

  useEffect(() => {
    if (userNextChapter) {
      const updateNextCountdown = () => {
        const now = new Date();
        const nextChapterDate = new Date(userNextChapter);
        const timeDiff = nextChapterDate - now;

        if (timeDiff <= 0) {
          setNextTimeLeft('Disponible');
          return;
        }

        const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
        const seconds = Math.floor((timeDiff / 1000) % 60);

        const formatNumber = (num) => (num < 10 ? `0${num}` : num);
        const dayLabel = days === 1 ? 'jour' : 'jours';

        setNextTimeLeft(
          `${days} ${dayLabel}, ${formatNumber(hours)}h ${formatNumber(minutes)}m ${formatNumber(seconds)}s`
        );
      };

      updateNextCountdown();
      const interval = setInterval(updateNextCountdown, 1000);
      return () => clearInterval(interval);
    }
  }, [userNextChapter]);

  return (
    <li className={`${available ? 'available' : 'unavailable'} ${firstElement && userDefi === content.id ? 'first-element' : ''}`}>
      <h3 className={firstElement ? 'bold' : ''}>{content?.title}</h3>
      {firstElement && parseInt(userDefi) === parseInt(content.id) ? (
        <>
          <p>Expire dans {timeLeft}</p>
          <ul className='life'>
            {Array.from({ length: 7 }, (_, index) => (
              <li key={index} className={index < dayLeft / 2 ? 'full' : ''}></li>
            ))}
          </ul>
        </>
      ) : (
        ""
      )}
      {firstElement && userDefi !== content.id ? (
        <p>Disponible dans {nextTimeLeft}</p>
      ) : (
        ""
      )}
    </li>
  );
};

export default Episode;